<div *ngIf="customFields?.length" class="component-container">
  <form *ngIf="form" [formGroup]="form">
    <div *ngFor="let row of rows" class="ui-g form-rows">
      <ng-container *ngFor="let customField of row">
        <div
          *ngIf="setFieldVisibility(customField)"
          class="ui-lg-{{ getFieldWidth(customField) }} ui-lg-offset-{{ getFieldOffset(customField) }} ui-xs-12 field-rows">
          <label
            *ngIf="customField.label && customField.type !== customFieldType.Checkbox"
            class="ui-g-5 field-label text-right-align"
            [ngClass]="{ required: setFieldMandatory(customField) }"
            [for]="customField.name">
            <ng-container *ngIf="!customField.emptyLabel">
              {{ customField.label | translate }}
            </ng-container>
          </label>

          <input
            *ngIf="customField.type === customFieldType.Text"
            class="ui-input pInputText"
            [formControl]="form.get(customField.name)"
            [id]="customField.name"
            pInputText
            [readonly]="disabled || customField.readonly" />

          <div *ngIf="customField.type === customFieldType.Number">
            <input
              class="ui-input pInputText"
              [formControl]="form.get(customField.name)"
              [id]="customField.name"
              type="number"
              pInputText
              [readonly]="disabled || customField.readonly"
              onkeydown="return event.keyCode !== 69" />
            <span *ngIf="customField.units" class="unit-margin">{{ customField.units }}</span>

            <div class="hint_text" *ngIf="customField.hint">
              {{ customField.hint | translate }}
            </div>
          </div>

          <div *ngIf="customField.tooltip" class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 hint-section text-right-align">
            <i
              class="pi pi-info-circle hint-icon"
              tooltipStyleClass="netz-info-tooltip"
              pTooltip="{{ customField.tooltip | translate }}"></i>
          </div>

          <ng-container *ngIf="customField.type === customFieldType.Dropdown || customField.type === customFieldType.DynamicDropdown">
            <p-dropdown
              [options]="dropdownOptions[customField.name]"
              [formControl]="form.get(customField.name)"
              [id]="customField.name"
              [placeholder]="customField.placeholder || '-Select-'"
              [readonly]="disabled || customField.readonly">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  <ng-container *ngIf="customField.dropdownTypeKey">
                    {{ 'lookup.' + customField.dropdownTypeKey + '.options.' + item['value'] + '.name' | translate }}
                  </ng-container>

                  <ng-container *ngIf="!customField.dropdownTypeKey">
                    {{ item.label }}
                  </ng-container>
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <ng-container *ngIf="customField.dropdownTypeKey">
                    {{ 'lookup.' + customField.dropdownTypeKey + '.options.' + option['value'] + '.name' | translate }}
                  </ng-container>

                  <ng-container *ngIf="!customField.dropdownTypeKey">
                    {{ option.label }}
                  </ng-container>
                </div>
              </ng-template>
            </p-dropdown>
            <span *ngIf="customField.units" class="unit-margin">{{ customField.units }}</span>
          </ng-container>

          <p-inputSwitch
            appEnterClick
            *ngIf="customField.type === customFieldType.Switch"
            [formControl]="form.get(customField.name)"
            [readonly]="disabled || customField.readonly"></p-inputSwitch>

          <ng-container *ngIf="customField.type === customFieldType.CheckOptions">
            <p-radioButton
              *ngFor="let option of customField.checkOptionsData"
              class="radio-button-alignment"
              [formControl]="form.get(customField.name)"
              [name]="customField.name"
              [id]="customField.name"
              [value]="option.value"
              [disabled]="disabled || customField.readonly"
              [label]="option.label | translate"></p-radioButton>
          </ng-container>

          <p-checkbox
            appEnterClick
            *ngIf="customField.type === customFieldType.Checkbox"
            binary="true"
            [readonly]="disabled || customField.readonly"
            [formControl]="form.get(customField.name)"
            [id]="customField.name"
            [label]="customField.label | translate"></p-checkbox>
        </div>
      </ng-container>
    </div>
  </form>
</div>
